import { Button } from '@/shared/ui/Button';
import { Input } from '@/shared/ui/Input/Input';
import { Typography } from '@/shared/ui/Typography/Typography';
import * as React from 'react';
import { Link } from 'react-router-dom';
import LinkArrowIcon from "@/assets/icons/linkArrow.svg?react";
import TelegramIcon from "@/assets/icons/telegram.svg?react";
import WhatsappIcon from "@/assets/icons/whatsapp.svg?react";
import { useAppSelector } from '@/app/store/hooks';
import { selectContacts } from '@/entities/home_content/model/selectors';

export interface IFloorPlansDownloadProps {
    url: string
}

type userInfoType = {
    name: {
        value: string;
        error: string;
    };
    phone: {
        value: string;
        error: string;
    };
    term: boolean;
};

export function FloorPlansDownload(props: IFloorPlansDownloadProps) {

    const [userInfo, setUserInfo] = React.useState<userInfoType>({
        name: { value: "", error: "" },
        phone: { value: "", error: "" },
        term: false,
    });

    const ButtonsRef = React.useRef<HTMLDivElement>(null)

    const contacts = useAppSelector(selectContacts);

    const validate = () => {
        let isValid = true;
        const newUserInfo = { ...userInfo };

        if (!userInfo.name.value.trim()) {
            newUserInfo.name.error = "Введите имя";
            isValid = false;
        } else {
            newUserInfo.name.error = "";
        }

        const phoneRegex = /^\+?[0-9\s-]{10,15}$/;
        if (!userInfo.phone.value.trim()) {
            newUserInfo.phone.error = "Введите номер телефона";
            isValid = false;
        } else if (!phoneRegex.test(userInfo.phone.value)) {
            newUserInfo.phone.error = "Неверный формат номера";
            isValid = false;
        } else {
            newUserInfo.phone.error = "";
        }

        setUserInfo(newUserInfo);
        return isValid;
    };

    const handleInputChange = (
        field: "name" | "phone",
        value: string
    ) => {
        setUserInfo((prev) => ({
            ...prev,
            [field]: {
                ...prev[field],
                value,
                error: "",
            },
        }));
    };

    const handleCheckboxChange = (value: boolean) => {
        setUserInfo((prev) => ({ ...prev, term: value }));
    };

    const handleSubmit = () => {

        if (!userInfo.term) {
            alert("Пожалуйста, подтвердите согласие на обработку данных.");
            return;
        }

        if (!validate()) {
            return;
        }

        if (props.url) {
            const link = document.createElement('a');
            link.href = props.url;
            link.click();
        }

        setUserInfo({
            name: { value: "", error: "" },
            phone: { value: "", error: "" },
            term: false,
        })
    };


    React.useEffect(() => {
        const container = ButtonsRef.current;

        if (!container) return

        const middle = (container.scrollWidth - container.clientWidth) / 2;
        container.scrollLeft = middle;
    }, [])

    return (
        <div className='flex flex-col gap-[12px] md:gap-[40px] md:flex-row'>

            <Typography className='text-[20px] font-bold md:w-min'>
                СКАЧАЙТЕ АЛЬБОМ ПЛАНИРОВОК
            </Typography>

            <div className='flex flex-col gap-[12px] md:w-auto md:flex-1'>
                <Input
                    className="h-[43px] rounded-full px-[24px] bg-white border border-black"
                    placeholder="Имя"
                    type="text"
                    value={userInfo.name.value}
                    error={userInfo.name.error}
                    onChange={(e) => handleInputChange("name", e.target.value)}
                    required
                />

                <Input
                    className="h-[43px] rounded-full px-[24px] bg-white border border-black"
                    name="phone"
                    type="tel"
                    value={userInfo.phone.value}
                    error={userInfo.phone.error}
                    placeholder="Телефон"
                    pattern="^\\+?[0-9\\s-]{10,15}$"
                    onChange={(e) => handleInputChange("phone", e.target.value)}
                    required
                />

                <div className="flex flex-row items-start gap-2">
                    <input
                        id="agreeTerms"
                        name="agreeTerms"
                        type="checkbox"
                        checked={userInfo.term}
                        className="mt-1 text-[var(--black-grey)] accent-[var(--black-grey)] focus:ring-0"
                        onChange={(e) => handleCheckboxChange(e.target.checked)}
                        required
                    />
                    <label htmlFor={'agreeTerms'}>
                        <Typography className='text-[var(--black-grey)] text-[10px]'>
                            Я полностью ознакомился и согласен с
                            <Link to="/privacy-policy" className='text-[#116ACC]'> Пользовательским соглашением, Политикой обработки персональных данных и файлов Cookie.</Link>
                            , и предоставляю конкретное, предметное, информированное, сознательное и однозначное Согласие на обработку моих персональных данных.

                        </Typography>
                    </label>
                </div>

                <Button
                    endIcon={<LinkArrowIcon className="w-[30px] h-[30px]" />}
                    text="Скачать альбом"
                    bg="black"
                    className="w-full text-[16px] h-[38px] p-[4px] pl-[16px] md:h-[42px] md:pr-[6px] hidden md:flex"
                    type="submit"
                    onClick={handleSubmit}
                />

                <div className='gap-[12px] hidden md:flex'>
                    <a href={contacts?.telegramUrl} target='_blank' className='w-full'>
                        <Button
                            endIcon={<TelegramIcon className="w-[30px] h-[30px]" />}
                            text="Скачать в Telegram"
                            className="w-full text-[16px] h-[38px] p-[4px] pl-[16px] md:h-[42px] md:pr-[6px] border border-black"
                            type="submit"
                        />
                    </a>

                    <a href={contacts?.whatsappUrl} target='_blank' className='w-full'>
                        <Button
                            endIcon={<WhatsappIcon className="w-[30px] h-[30px]" />}
                            text="Скачать в WhatsApp"
                            className="w-full text-[16px] h-[38px] p-[4px] pl-[16px] md:h-[42px] md:pr-[6px] border border-black"
                            type="submit"
                        />
                    </a>
                </div>

                <div 
                    className='flex overflow-x-auto gap-[10px] md:hidden [scrollbar-width:none] [-ms-overflow-style:none] [::-webkit-scrollbar]:hidden' 
                    ref={ButtonsRef}
                >
                    <a href={contacts?.telegramUrl} target='_blank'>
                        <Button
                            endIcon={<TelegramIcon className="w-[30px] h-[30px]" />}
                            text="Скачать в Telegram"
                            className="w-full text-[16px] h-[38px] p-[4px] pl-[16px] md:h-[42px] md:pr-[6px] border"
                            type="submit"
                        />
                    </a>
                    <Button
                        endIcon={<LinkArrowIcon className="w-[30px] h-[30px]" />}
                        text="Скачать альбом"
                        bg="black"
                        className="w-full text-[16px] h-[38px] p-[4px] pl-[16px] md:h-[42px] md:pr-[6px]"
                        type="submit"
                        onClick={handleSubmit}
                    />
                    <a href={contacts?.whatsappUrl} target='_blank'>
                        <Button
                            startIcon={<WhatsappIcon className="w-[30px] h-[30px]" />}
                            text="Скачать в WhatsApp"
                            className="w-full text-[16px] h-[38px] p-[4px] pl-[4px] md:h-[42px] md:pr-[6px] border"
                            type="submit"
                        />
                    </a>
                </div>

            </div>
        </div>
    );
}
